export const ApiStatus = {
  LOADING: "LOADING",
  SUCCESS: "SUCCESS",
  FAILURE: "FAILURE",
  SAVING: "SAVING",
  CLEAR: "CLEAR",
  REJECTED: "REJECTED",
};
